import React from 'react';
import { SwatchButton } from './Swatch';
import styled from 'styled-components';
import styledTheme from 'common/theme';

interface SwatchListProps {
  colors: string[];
  onColorClick?: (color: string) => void;
  disabledColors?: string[];
}

export const SwatchListContainer = styled.div`
  position: absolute;
  height: 110px;
  box-shadow: 0px 0.854px 2.563px 0px rgba(0, 0, 0, 0.12);
  width: 97px;
  z-index: 99;
  border: 1px solid #fff;
  padding: 5px;
  background: #fff;
  border-radius: 5px;

  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(5, 1fr);
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    width: 85px;
    background: ${styledTheme.colors.white};
  }
`;

export const SwatchList = ({ colors, onColorClick, disabledColors }: SwatchListProps): JSX.Element => {

  return (
    <SwatchListContainer className="swatch-list">
      <div className="list">
        {colors.map((color, idx) => {
          const isDisabled = disabledColors?.includes(color) ?? false;
          return (
            <SwatchButton
              key={idx}
              color={color}
              onClick={onColorClick}
              disabled={isDisabled}
            />
          );
        })}
      </div>
    </SwatchListContainer>
  );
};
